module.exports = __webpack_public_path__ + "d321fa78bb7190a8ca7e14213ef63203.otf";